import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListBuilderResale from "../Components/Builder Resale/listBuilders";
import AddBuilderResale from "../Components/Builder Resale/addBuilder";
import EditBuilderResale from "../Components/Builder Resale/editBuilder";
import ViewBuilderResale from "../Components/Builder Resale/viewBuilder";

const BuilderResaleRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes("add");
  // const canEdit = Array.isArray(accessCode) && accessCode.includes("edit");

  return (
    <Routes>
      <Route
        path="/builder_resale"
        element={<ListBuilderResale />}
      />
      <Route
        path="/builder_resale/add"
        element={canAdd ? <AddBuilderResale /> : <Navigate to="/builder-resale" replace />}
      />
      <Route
        path="/builder_resale/edit/:id"
        element={canAdd ? <EditBuilderResale /> : <Navigate to="/builder-resale" replace />}
      />
      <Route
        path="/builder_resale/view/:id"
        element={<ViewBuilderResale />}
      />
    </Routes>
  );
};

export default BuilderResaleRoutes;